import { RootState } from "store/store"
import { EstadoRequisicao } from "store/types";


class ListaSelector {
  static readonly carregando = (it: RootState) => it.servidores.estado === EstadoRequisicao.CARREGANDO;
  static readonly erros = (it: RootState) => it.servidores.erros;

  static readonly elementos = (it: RootState) => it.servidores.elementos;

  static readonly paginacao = (it: RootState) => it.servidores.pagina;
  static readonly ordem = (it: RootState) => it.servidores.ordem;
}

export class ServidoresSelector {
  static readonly lista = ListaSelector;
}
